export default __webpack_public_path__ + "static/media/todo-green.8081936e.svg";